import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import './ImageSlider.css'; // Add CSS file

const ImageSlider = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/getSliderImages`)
      .then(response => response.json())
      .then(data => {
        const imageUrls = data.map(slider => slider.image);
        setImages(imageUrls);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching slider images:', error);
        setLoading(false);
      });
  }, []);

  const settings = {
    dots: true,                // Show navigation dots like TradeIndia
    infinite: true,            
    speed: 800,                // Smoother transition
    slidesToShow: 1,           
    slidesToScroll: 1,         
    autoplay: true,            
    autoplaySpeed: 4000,       // Slightly slower for better viewing
    arrows: true,              // Show navigation arrows like TradeIndia
    fade: true,                // Fade transition for professional look
    pauseOnHover: true,        // Pause on hover
    dotsClass: 'slick-dots',
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  if (loading) {
    return (
      <div className="slider-loading">
        <div className="loading-spinner"></div>
        <p>Loading slider...</p>
      </div>
    );
  }

  return (
    <div className="tradeindia-slider-container">
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index} className="slider-slide">
            <div className="slide-content">
              <img 
                src={`${process.env.REACT_APP_API_URL}/${image}`} 
                alt={`Slide ${index + 1}`} 
                className="slider-image"
              />
            
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

// Custom Arrow Components
const CustomPrevArrow = ({ onClick }) => (
  <div className="custom-arrow-home custom-prev-arrow-home" onClick={onClick}>
    <i className="fas fa-chevron-left"></i>
  </div>
);

const CustomNextArrow = ({ onClick }) => (
  <div className="custom-arrow-home custom-next-arrow-home" onClick={onClick}>
    <i className="fas fa-chevron-right"></i>
  </div>
);

export default ImageSlider;